import {combineReducers} from 'redux';

import dimensions from './dimensions-reducer';
import states from './states-reducer';
import counties from './counties-reducer';
import search from './search-reducer';

const rootReducer = combineReducers({
  dimensions,
  states,
  counties,
  search
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js